import type { VisitStatsData } from '@/service/visit';

// ==================== 页面 URL 转可读名称 ====================

const pageNameMap: Record<string, string> = {
    '/': '首页',
    '/effects': '特效',
    '/demo': 'Demo',
    '/demo/chat': 'AI 助手',
    '/demo/group-chat': '群聊',
    '/demo/vr': 'VR全景看房',
    '/interview-question': '面试题',
    '/blog': '学习笔记',
    '/blog/article': '文章详情',
    '/ad-ui': 'AdUI',
    '/docs': 'API 文档',
};

/**
 * 简化页面 URL 为可读名称
 * 优先精确匹配，然后尝试前缀匹配（支持动态路由如 /blog/article/123）
 */
export const shortPage = (url: string): string => {
    if (pageNameMap[url]) return pageNameMap[url];
    // 尝试前缀匹配（处理动态路由）
    for (const [prefix, name] of Object.entries(pageNameMap)) {
        if (url.startsWith(prefix + '/') || url.startsWith(prefix + '?')) {
            return name;
        }
    }
    return url;
};

// ==================== Mock 数据 ====================

export const mockVisitStats: VisitStatsData = {
    totalVisits: 128456,
    uniqueVisitors: 45678,
    todayVisits: 789,
    todayUniqueVisitors: 234,
    topPages: [
        { page_url: '/', visits: 38520, unique_visitors: 12640 },
        { page_url: '/blog', visits: 28450, unique_visitors: 9870 },
        { page_url: '/demo', visits: 18230, unique_visitors: 6520 },
        { page_url: '/interview-question', visits: 12560, unique_visitors: 4530 },
        { page_url: '/demo/chat', visits: 9870, unique_visitors: 3210 },
        { page_url: '/demo/vr', visits: 7650, unique_visitors: 2890 },
        { page_url: '/blog/article', visits: 6540, unique_visitors: 2340 },
        { page_url: '/demo/group-chat', visits: 2860, unique_visitors: 980 },
        { page_url: '/interview-question/article', visits: 1980, unique_visitors: 720 },
        { page_url: '/ad-ui', visits: 1540, unique_visitors: 610 },
    ],
    topRegions: [
        { location: '广东省', visits: 28450, unique_visitors: 9870 },
        { location: '北京市', visits: 21340, unique_visitors: 7650 },
        { location: '上海市', visits: 18760, unique_visitors: 6540 },
        { location: '浙江省', visits: 15420, unique_visitors: 5430 },
        { location: '江苏省', visits: 12890, unique_visitors: 4320 },
        { location: '四川省', visits: 10560, unique_visitors: 3650 },
        { location: '湖北省', visits: 8720, unique_visitors: 2980 },
        { location: '福建省', visits: 7650, unique_visitors: 2650 },
        { location: '山东省', visits: 6540, unique_visitors: 2340 },
        { location: '湖南省', visits: 5430, unique_visitors: 1980 },
        { location: '河南省', visits: 4870, unique_visitors: 1760 },
        { location: '安徽省', visits: 3980, unique_visitors: 1450 },
    ],
    dailyTrend: [
        { day: '2026-06-15', visits: 825, unique_visitors: 312 },
        { day: '2026-06-16', visits: 942, unique_visitors: 356 },
        { day: '2026-06-17', visits: 876, unique_visitors: 334 },
        { day: '2026-06-18', visits: 1102, unique_visitors: 423 },
        { day: '2026-06-19', visits: 1256, unique_visitors: 467 },
        { day: '2026-06-20', visits: 987, unique_visitors: 378 },
        { day: '2026-06-21', visits: 789, unique_visitors: 234 },
    ],
};
